// extracted by mini-css-extract-plugin
export var cardHeader = "_rw-0";
export var reorderHandle = "_rw-3";
export var titleArea = "_rw-1";
export var titleAreaWithHandle = "_rw-2";